import React from 'react';
import { Dumbbell, Info } from 'lucide-react';

/**
 * Компонент с секцией выбора уровня физической активности
 */
const ActivityLevelSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  activityLevels 
}) => {
  return (
    <div className="mb-6 bg-emerald-50 dark:bg-emerald-900/20 p-4 rounded-lg border border-emerald-200 dark:border-emerald-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Dumbbell className="w-5 h-5 mr-2 text-emerald-500" />
        Уровень физической активности
      </h3>
      
      <div className="grid grid-cols-1 gap-2">
        {activityLevels.map((level) => (
          <label 
            key={level.id}
            className={`flex items-start p-3 rounded-lg border transition-colors cursor-pointer
              ${formData.activityLevel === level.id 
                ? 'bg-emerald-100 border-emerald-300 text-emerald-800 dark:bg-emerald-900/40 dark:border-emerald-700 dark:text-emerald-200'
                : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              }`}
          >
            <input
              type="radio"
              name="activityLevel"
              value={level.id}
              checked={formData.activityLevel === level.id}
              onChange={handleInputChange}
              className="form-radio mt-1"
            />
            <div className="ml-3">
              <span className="block font-medium text-gray-900 dark:text-white">
                {level.name} (×{level.factor})
              </span>
              <span className="text-sm text-gray-600 dark:text-gray-400">
                {level.description}
              </span>
            </div>
          </label>
        ))}
        {errors.activityLevel && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.activityLevel}
          </p>
        )}
      </div>

      <div className="mt-4 bg-white dark:bg-gray-800 p-3 rounded-lg border border-emerald-200 dark:border-emerald-800">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-emerald-600 dark:text-emerald-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-emerald-700 dark:text-emerald-300 mb-1">
              Как выбрать правильный уровень активности?
            </h4>
            <p className="text-xs text-emerald-600 dark:text-emerald-400">
              Учитывайте всю вашу активность в течение дня, а не только тренировки. 
              Большинство офисных работников относятся к категории "Сидячий образ жизни" или 
              "Легкая активность", даже если они тренируются 2-3 раза в неделю.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityLevelSection;